import { ThemeColorVariable } from "@caspeco/casper-ui-library";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { Spinner as ChakraSpinner, type HTMLChakraProps } from "@chakra-ui/react";

type SpinnerProps = Omit<HTMLChakraProps<"div">, "size"> & {
	size?: "xs" | "sm" | "md" | "lg" | "xl";
};
/** Mirrors Chakra spinner sizes with raw CSS values, bypassing Chakra v3's
 *  Panda CSS token resolution which doesn't work inside the Casper ThemeProvider. */
const sizeMap: Record<NonNullable<SpinnerProps["size"]>, string> = {
	xs: "0.75rem",
	sm: "1rem",
	md: "1.25rem",
	lg: "2rem",
	xl: "2.5rem",
};

const Spinner = ({ size = "md", style, ...props }: SpinnerProps) => {
	const spinnerSize = sizeMap[size];

	return (
		<ChakraSpinner
			color={ThemeColorVariable.Accent}
			style={{ "--spinner-size": spinnerSize, ...style } as React.CSSProperties}
			{...props}
		/>
	);
};

export default Spinner;
